'use client'

import { type ReactNode } from 'react'
import { IconHolder } from "../icon-holder"


// import Glob from '@/assets/icons/Glob';

export function ExperienceCard({
  title,
  description,
  Icon,
}: {
  title: string
  description: string
  Icon: ReactNode
}) {
  return (
    <div className='flex items-center p-6 bg-white rounded-xl shadow-lg lg:max-w-[19.06rem] flex-[1] min-w-3xs md:min-w-auto'>
      <IconHolder className='text-dark w-14 h-14'>{Icon}</IconHolder>
      <div className='ml-4'>
        <p className='xl:text-lg  text-xs font-bold text-[#212B49] leading-[22px]'>
          {title}
        </p>
        <p className='xl:text-xs text-[9px] font-light text-[#797979]'>
          {description}
        </p>
      </div>
    </div>
  )
}
